"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_URL_SUBDOMAIN = exports.DEPRECATED_DOMAINS = exports.ACTUAL_DOMAIN = void 0;
exports.ACTUAL_DOMAIN = 'shef.com';
exports.DEPRECATED_DOMAINS = ['myshef.com', 'www.myshef.com'];
exports.SHORT_URL_SUBDOMAIN = 'i';
//# sourceMappingURL=Domains.js.map